import React, { Component } from 'react';
import { useEffect, useState } from 'react';

import { ajaxor2, ajaxor22 } from '../common/basic';

import Swiper from 'swiper';
import '../../public/dist/swiper/swiper.css';



export default props=> {
  // console.log("pan4: ", props);
  const [vBanners, setBanners] = useState([]);
  useEffect(() => {
    // console.log("useEffect: ");
    ajaxor22({
      url: '/promotions/imageBanners',
      callback: callback,
    });
    function callback(rd) {
      // console.log("rd: ", rd);
      setBanners(rd);
      initSwiper();
    }
  }, []);

  function initSwiper() {
    var mySwiper = new Swiper('#id1.swiper-container', {
      autoplay: {
        delay: 5000,
        // disableOnInteraction: false,
      },


      // Optional parameters
      direction: 'horizontal',
      loop: true,

      // If we need pagination
      pagination: {
        el: '#id1 .swiper-pagination',
        clickable: true,
      }
    });


    var mySwiper2 = new Swiper('#id2_mobile.swiper-container', {

      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },


      // Optional parameters
      direction: 'horizontal',
      loop: true,

      // If we need pagination
      pagination: {
        el: '#id2_mobile .swiper-pagination'
      }
    });

  }


  return (<div className="pan4">
    <style jsx>{`

.pan4{
  padding:35px 0 0 0;
}

.swiper-container{
  display:block;
}
#id1 .swiper-pagination{
  margin-bottom: -10px;
}

#id2_mobile.swiper-container{
  display:none;
}

@media all and (max-width:606px) {
  .pan4{
    padding:24px 0 0 0;
  }

  #id1.swiper-container{
    display:none;
  }

  #id2_mobile.swiper-container{
    display:block;
    height: 180px;
  }

  #id2_mobile .swiper-pagination{
    // margin-bottom: -3px;
  }

//  조정안됨  // 
  #id2_mobile.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet
  {
    margin:0;
  }

}
`}</style>
  {(vBanners && vBanners.length <= 0) ? <></>:
    <div id="id1" className={"swiper-container " + (vBanners && vBanners.length)}>
      <div className="swiper-wrapper">
        {vBanners && vBanners.map((v,i)=>(
          <div key={i} className="swiper-slide">
            {v.link ?
              <a href={v.link} target="_blank">
                <img className="image" src={
                  (v.images && v.images.lg
                    ? v.images.lg.url
                    : "/assets/images0226/200224.png"
                  )
                } />
              </a>
            :
              <img className="image" src={
                (v.images && v.images.lg
                  ? v.images.lg.url
                  : "/assets/images0226/200224.png"
                )
              } />
            }
          </div>


        ))}
      </div>
      <div style={{ display: (vBanners && vBanners.length > 0 ? "block" : "none") }} className="swiper-pagination"></div>
    </div>
}
    <div id="id2_mobile" className="swiper-container ">
      <div className="swiper-wrapper">
        {vBanners.map((v, i) => (
          <div key={i} className="swiper-slide">
            {v.link ?
              <a href={v.link} target="_blank">
                <img className="image" src={
                  (v.images && v.images.lg
                    ? v.images.sm.url
                    : "/assets/images0226/200224.png"
                  )
                } />
              </a>
              :

              <img className="image" src={
                (v.images && v.images.sm
                  ? v.images.sm.url
                  : "/assets/images0226/200224.png"
                )
              } />
            }
          </div>
        ))}
      </div>
      <div className="swiper-pagination"></div>
    </div>

  </div>);

}
